<template>
  <v-container>
    <v-layout row wrap >
      <v-flex xs12 style='text-align:left'>
        <strong>You are required to submit the following documents: </strong><br/>
        Copy of practice site discounted sliding fee schedule in effect for the previous 12 months as well as for current and ongoing use <br/>
        Copy of the healthcare provider’s job description <br/>
        Copy of employment contract and/or agreement showing start date <br/>  
        Copy of the healthcare provider’s permanent Wyoming professional license <br/>
        Proof of healthcare provider’s U.S. Citizenship or U.S. National status (certified birth certificate or passport)
      </v-flex>
    </v-layout>
    <br/><br/>
    <v-expansion-panel>
      <v-expansion-panel-content>
        <template slot="header"><div style='width:100%'>Sliding Fee Schedule</div></template>
        <v-card>
          <v-card-text>
            <doc-item v-for="d in slidingFeeSchedule" :key="d.ID" :doc="d.Document"></doc-item>
            <upload :app_id="app_id" type="SlidingFeeSchedule" v-on:upload="getDocs"></upload>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
      <v-expansion-panel-content>
        <template slot="header"><div style='width:100%'>Job Description</div></template>
        <v-card>
          <v-card-text>
            <doc-item v-for="d in jobDescription" :key="d.ID" :doc="d.Document"></doc-item>
            <upload :app_id="app_id" type="JobDescription" v-on:upload="getDocs"></upload>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
      <v-expansion-panel-content>
        <template slot="header"><div style='width:100%'>Employment Contract</div></template>
        <v-card>
          <v-card-text>
            <doc-item v-for="d in employeeContract" :key="d.ID" :doc="d.Document"></doc-item>
            <upload :app_id="app_id" type="EmployeeContract" v-on:upload="getDocs"></upload>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
      <v-expansion-panel-content>
        <template slot="header"><div style='width:100%'>Professional License</div></template>
        <v-card>
          <v-card-text>
            <doc-item v-for="d in professionalLicense" :key="d.ID" :doc="d.Document"></doc-item>
            <upload :app_id="app_id" type="ProfessionalLicense" v-on:upload="getDocs"></upload>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
      <v-expansion-panel-content>
        <template slot="header"><div style='width:100%'>Proof of Citizenship</div></template>
        <v-card>
          <v-card-text>
            <doc-item v-for="d in proofOfCitizenship" :key="d.ID" :doc="d.Document"></doc-item>
            <upload :app_id="app_id" type="ProofOfCitizenship" v-on:upload="getDocs"></upload>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-container>
</template>
<script>
import DocumentUploadVue from './DocumentUpload.vue'
import DocumentItemVue from './DocumentItem.vue'
export default {
  props: {
    ApplicationDocuments: Array,
    app_id: Number,
  },
  data(){
    return {
      
    }
  },
  created(){
    
  },
  computed: {
    slidingFeeSchedule(){
      return this.filter('SlidingFeeSchedule')
    },
    jobDescription(){
      return this.filter('JobDescription')
    },
    employeeContract(){
      return this.filter('EmployeeContract')
    },
    professionalLicense(){
      return this.filter('ProfessionalLicense')
    },
    proofOfCitizenship(){
      return this.filter('ProofOfCitizenship')
    }
  },
  methods: {
    filter(type){
      if(this.ApplicationDocuments){
        return this.ApplicationDocuments.filter(i => {
          return i.Type == type
        })
      }
      return []
    },
    getDocs(){
      axios.get(`Document_Application/${this.app_id}`)
        .then(response => {
          this.ApplicationDocuments = response.data
        }).catch(err => {
          console.log(err.response.data)
        })
    }
  },
  watch: {
    ApplicationDocuments: {
      handler(val){
        this.$emit('input', val)
      },
      deep: true
    },
  },
  components: {
    'upload' : DocumentUploadVue,
    'doc-item' : DocumentItemVue
  },
}
</script>
<style scoped>
  
</style>